import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@material-ui/core';
import {Print as PrintIcon} from '@material-ui/icons';
import moment from 'moment';
import {fetchAccountReadingNightsAchievedDate} from 'api/account';

export default class ReaderAwardDetail extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    award: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      date: null,
    };
    this.awardImgRef = React.createRef();
    this.printAward = this.printAward.bind(this);
  }

  componentDidMount() {
    const {
      award: {points},
    } = this.props;
    fetchAccountReadingNightsAchievedDate(points).then(({date}) => {
      this.setState({
        date,
      });
    });
  }

  componentWillUnmount() {
    const iframe = document.querySelector('#print-award');
    if (iframe) {
      iframe.remove();
    }
  }

  printAward() {
    let iframe = document.querySelector('#print-award');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.setAttribute('id', 'print-award');
    } else {
      const iframeBody = iframe.contentDocument.querySelector('body');
      for (const childNode of iframeBody.childNodes) {
        childNode.remove();
      }
    }
    document.querySelector('body').appendChild(iframe);
    const awardBlock = document.createElement('div');
    awardBlock.innerHTML = this.awardImgRef.current.innerHTML;
    awardBlock.style.width = '100%';
    awardBlock.style.height = '100%';

    iframe.contentDocument.querySelector('body').appendChild(awardBlock);
    iframe.contentDocument
      .querySelector('head')
      .insertAdjacentHTML(
        'beforeend',
        '<link href="https://fonts.googleapis.com/css?family=Roboto:400,700|Shadows+Into+Light" rel="stylesheet" type="text/css">',
      );
    iframe.contentWindow.print();
  }

  render() {
    const {date} = this.state;
    const {user, award} = this.props;
    return (
      <div>
        <Button className="award-print-btn" variant="contained" color="secondary" onClick={this.printAward}>
          <PrintIcon />
          Print
        </Button>
        <div ref={this.awardImgRef} style={{height: '100%', width: '100%'}}>
          <img src={`${process.env.SERVER_BASE_URL}${award.image}`} style={{height: '100%', width: '100%'}} />
          <div
            className="awarded-user"
            style={{
              position: 'absolute',
              fontSize: '3vh',
              fontFamily: '"Shadows Into Light", cursive',
              top: '80%',
              left: '50%',
              transform: 'translate(-50%)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div>{`${user.firstName} ${user.lastName}`}</div>
            <div>{date && moment(date).format('dddd Do MMMM, YYYY')}</div>
          </div>
        </div>
      </div>
    );
  }
}
